import { Command } from '@nest/internal-frontend';
import { Play } from 'lucide-react';
import { useNavigate } from 'react-router';
import { useTerminalClient } from '../../../client-rpc-router';

export const useCommandOutboundDeliveryOrderStartProcess = ({ id, documentTypeId, queueId }: { id?: number; documentTypeId?: number; queueId?: number }): Command => {
	const client = useTerminalClient();
	const navigate = useNavigate();

	return {
		id: 'start-process',
		label: 'Zpracovat doklad',
		icon: <Play className="h-4 w-4" />,
		shortcut: undefined,
		disabled: !id,
		loading: undefined,
		run: async () => {
			if (id) {
				await client.outboundDeliveryOrders.startOutboundDeliveryOrderProcessMutation.execute({ id });
				navigate(`/outbound/delivery/orders/${id}/process?documentTypeId=${documentTypeId}&queueId=${queueId}`);
			}
		}
	};
};
